var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { makeAutoObservable, reaction } from "mobx";
import { singleton } from "tsyringe";
import { StorageManagerFactory } from "../storage";
/**
 * DialogStateManager is responsible for managing the state of dialogs in the application.
 * It uses localStorage to persist the state across page reloads.
 */
let DialogStateManager = class DialogStateManager {
    constructor(storageManagerFactory) {
        this.storageManager = storageManagerFactory.forDialogState();
        this._state = this.readDialogsState();
        makeAutoObservable(this);
        reaction(() => ({ ...this._state }), (state) => {
            this.storageManager.store(state);
        });
    }
    readDialogsState() {
        const restored = this.storageManager.restore();
        if (restored !== null) {
            return restored;
        }
        return {
            freeDeliveryWithoutAddressBottomSheet: true,
            freeDeliveryWithAddressStickyAlert: true,
        };
    }
    get state() {
        return this._state;
    }
};
DialogStateManager = __decorate([
    singleton(),
    __metadata("design:paramtypes", [typeof (_a = typeof StorageManagerFactory !== "undefined" && StorageManagerFactory) === "function" ? _a : Object])
], DialogStateManager);
export { DialogStateManager };
